import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import {UserService} from '@core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard  {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return  route.data.acceptedRole.includes(this.userService.user.role) || this.router.parseUrl('/events');
  }
}
